import axios from 'axios';

const api = axios.create({ baseURL: '/api' });

api.interceptors.request.use(cfg => {
  const token = localStorage.getItem('token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  r => r,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export const authAPI = {
  login: (email, mot_de_passe) => api.post('/auth/login', { email, mot_de_passe }),
  me: () => api.get('/auth/me'),
  changerMdp: (ancien, nouveau) => api.post('/auth/changer-mdp', { ancien, nouveau }),
};

export const dashboardAPI = {
  get: () => api.get('/dashboard'),
  getRecommandations: () => api.get('/dashboard/recommandations'),
};

export const villasAPI = {
  liste: () => api.get('/villas'),
  detail: (id) => api.get(`/villas/${id}/detail`),
  updateNotes: (id, data) => api.put(`/villas/${id}/notes`, data),
};

export const avanAPI = {
  get: (corps) => api.get(`/avancement/${corps}`),
  saisir: (corps, data) => api.post(`/avancement/${corps}`, data),
  bulk: (corps, data) => api.post(`/avancement/${corps}/bulk`, data),
};

export const problemesAPI = {
  liste: (params) => api.get('/problemes', { params }),
  creer: (data) => api.post('/problemes', data),
  modifier: (id, data) => api.put(`/problemes/${id}`, data),
};

export const usersAPI = {
  liste: () => api.get('/utilisateurs'),
  creer: (data) => api.post('/utilisateurs', data),
  modifier: (id, data) => api.put(`/utilisateurs/${id}`, data),
};

export const planningAPI = {
  liste: (params) => api.get('/planning', { params }),
  creer: (data) => api.post('/planning', data),
  modifier: (id, data) => api.put(`/planning/${id}`, data),
  supprimer: (id) => api.delete(`/planning/${id}`),
  syncArticles: (id, articles) => api.put(`/planning/${id}/articles`, { articles }),
  uploadDocument: (id, data) => api.post(`/planning/${id}/documents`, data),
  downloadDocument: (id) => api.get(`/planning/documents/${id}/download`, { responseType: 'blob' }),
  supprimerDocument: (id) => api.delete(`/planning/documents/${id}`),
};

export const typesTravauxAPI = {
  liste: () => api.get('/types-travaux'),
  creer: (data) => api.post('/types-travaux', data),
  supprimer: (id) => api.delete(`/types-travaux/${id}`),
};

export default api;
